import { render, staticRenderFns } from "./batchShipPrint.vue?vue&type=template&id=238ec844&scoped=true&"
import script from "./batchShipPrint.vue?vue&type=script&lang=js&"
export * from "./batchShipPrint.vue?vue&type=script&lang=js&"
import style0 from "./batchShipPrint.vue?vue&type=style&index=0&id=238ec844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238ec844",
  null
  
)

component.options.__file = "batchShipPrint.vue"
export default component.exports